import React,{useState,useEffect} from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import {Minus,Activity ,ChevronLeft,X,Plus ,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,
    HopIcon} from 'lucide-react';

import SectionsQuizAddMore from "./SectionsQuizAddMore";
import CreateSectionPopUp from "./CreateSectionPopUp";
import { createNewMockTest,createNewMockSection,getSectionsByQuizId, getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import Toggle from "../../../UI/Toggle";
import Snackbar from "../../../../Snackbar";
import SectionsQuizAddMoreLoading from "./SectionsQuizAddMoreLoading";

  
const SectionsQuiz= ({setHideSectionBar,parentID,quizObject,})=>{ 
    const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
   const [goNextPopUp, setGoNextPopUp] =useState(false);
    const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
           
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
    
     const [loader , setLoader] =useState({status:false});
     const [animate, setAnimate] = useState(false);
    
         const [deleteSectionPopUp, setDeleteSectionPopUp] = useState(false);
         const [deleteId, setDeleteId] = useState("");
            const [isLockSections, setIsLockSections] = useState();
      const [createNewSectionPopUp, setCreateNewSectionPopUp] = useState(false);
    // let allSections= allSectionsData
const [parentFolder, setParentFolder] = useState({ID:""});
    
        const [allSections, setAllSections] = useState([]);
       
        const [ visibility, setVisibility] = useState("public");
          
 const [itemArr, setItemArr] = useState(allSections);
   let newSection= { no:1, id: generateTimestamp()
          ,title:"" ,sectionName:"",lockTime:10,questions:[] } ;
     useEffect(() => {
        
       
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
    
      useEffect(()=>{
        fireGetQuizDataByQuizId();
        fireGetSectionDataByQuizId()
        // setCourseTitleData();
      },[])
   


      const handleBack=(e)=>{
  
        setLoader({status:true});
        
        history.goBack();
        }
        
 
    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.ID !== id);
        setItemArr(filteredItems);
        handleCreateNewSection("deleteItem","",id)
      };
      const updateItemtitle = (id, sectionName,sectionId) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, sectionName :sectionName } : item
        
        ); 
        
        setItemArr(updatedItems);
        handleCreateNewSection("sectionName",sectionName,sectionId)
       
      };
      const updateItemlockTime = (id, lockTime,sectionId) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, lockTime :lockTime } : item
        
        ); 
        
        setItemArr(updatedItems);
      
       handleCreateNewSection("lockTime",lockTime,sectionId)
      };
    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';

const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};

const handleDrop = (e, dropIndex) => {
  const dragIndex = e.dataTransfer.getData("dragIndex");
  if (dragIndex === dropIndex) return;

  const updatedItems = [...itemArr];
  const [draggedItem] = updatedItems.splice(dragIndex, 1);
  updatedItems.splice(dropIndex, 0, draggedItem);

  const reorderedItems = updatedItems.map((item, index) => ({
    ...item,
    ID: item.ID,
  }));
  setItemArr(reorderedItems);
  handleCreateNewSection("updateSections",reorderedItems);
  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
};

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
   const fireGetSectionDataByQuizId=()=>{
   setItemArrLoading([{},{}])
    setLoader({status:true});
    
      const apiData = dispatch(getSectionsByQuizId({testName:"",type:"section",
        postParent:quizObject?.ID,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
            // console.log(response)
          if(response?.sections){
            setItemArrLoading([])
        setResponseMessage(response?.message);  
        setSnackbarColor("rgba(144, 202, 249,1)");
      
         setItemArr( response?.sections?response?.sections:[])

       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }

       const fireGetQuizDataByQuizId=()=>{
   
    setLoader({status:true});
    
      const apiData = dispatch(getQuizDataByQuizId({testName:"",type:"section",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
          if(response?.quiz){
            
        setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
         setIsLockSections(response?.quiz?.isLockSections)
      
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
 const handleCreateNewMockTest=(editType,val)=>{
     
    
     
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTest({isLockSections:val,type:"mock",
            postParent:parentID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             
             ));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){ console.log(response?.quiz)
           if(response?.quiz){
             setIsLockSections(response?.quiz?.isLockSections)
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
       
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
  const handleCreateNewSection=(editType,val,sectionId)=>{
     let SendObject=""
     if(editType=="sectionName"){
        SendObject={sectionName:val,type:"section",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:sectionId?editType:"",postId:sectionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
            
         if(editType=="lockTime"){
        SendObject={lockTime:val,type:"section",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:sectionId?editType:"",postId:sectionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }if(editType=="deleteItem"){
        SendObject={visibility:val,type:"section",
            postParent:quizObject?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:sectionId?editType:"",postId:sectionId,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
            
            //   console.log(SendObject)
            
                                                                             
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockSection(SendObject));


       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
            console.log(response)
           if(response?.sections){
            if(editType=='sectionName'){
   if(sectionId==response?.sections?.ID){}else{setItemArr([...itemArr,response?.sections]); }
            }
            // else
            //  if(editType=='lockTime'){
            //     if(sectionId==response?.sections?.ID){}else{setItemArr([...itemArr,{...newSection,sectionName:response?.sections?.sectionName}]); }
            //  }
            //  if(editType=="allSections"){
            //  setItemArr( response?.quiz?.allSections?JSON.parse(response?.quiz?.allSections):[])
            //  }
     setLoader({status:false});
     
     setTimeout(()=>{
       
       setSnackbarVisible(false);
     
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
   
     return(<>
              {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 
    <div >  {createNewSectionPopUp?<CreateSectionPopUp  sendBackData={(data)=>{   handleCreateNewSection("sectionName",data,"")}} closeSectionPopUp={()=>{ setCreateNewSectionPopUp(false);}} /> :""}
  {deleteSectionPopUp?<div>
    <div   onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer",opacity:"0.2",background:"#000"}} onClick={()=>setDeleteSectionPopUp(false)} className="appDesignPopUpOpacity"> </div>
         <div   className="AreYouSurePopUp" style={{height:"200px",borderRadius: '20px'}}> 
         <h1 align="center" >   Are You Sure? </h1>
       
  
 <div className="bookmarkListScroll" style={{overflowY:"auto",height:"180px",overflowX:"hidden"}}>
 
     <div className="">
     
 
 
 
 
 
 </div>
 
 <div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
    
    transition: 'transform 2s ease, opacity 1s ease',
  }}><button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={(id)=>{setDeleteSectionPopUp(false)}}   className=" CoursesPreviewTopBtn"  type="submit"
   style={{border:"3px solid rgba(144, 202, 249,1)",color:"rgba(144, 202, 249,1)"}}> No </button>
 <button onMouseEnter={handleMouseEnter}
   onMouseLeave={handleMouseLeave} onClick={()=>{removeItem(deleteId);setDeleteSectionPopUp(false)}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"200px",cursor:"pointer",zIndex:99999,height:"55px"}} 
   className=" CoursesPreviewTopBtn"  type="submit"
  >Yes. Delete this section.</button>
 </div> 
 </div>
 
      </div>
 </div>:""}
    <div  className=""style={{margin:"10px"}}>
    <div  className=""style={{margin:"10px",display:"flex",justifyContent:"space-around"}}>
        <div  onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{ setHideSectionBar();   }}
               className="QuizAddSectionBtn"  > close </div>
       <div  onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{ setCreateNewSectionPopUp(true)  }}
               className="QuizAddSectionBtn"  > + Add Section </div></div>
                <div className="gridForFiftyFixed"style={{
              transform: animate ? 'scale(1)' : 'scale(.98)',
              opacity: animate ? 1 : 0.8,
              transition: 'transform 2s ease, opacity 2s ease',
            }}><div><h4>{loader?.statusPlatformiOS?"loading...":" Lock  Sections With Time Limit? "} </h4></div>
            <Toggle state={isLockSections} toggleState={(state)=>{setIsLockSections(state) ;handleCreateNewMockTest("isLockSections",state)}} />
               </div> 
               <div  className=" " style={{borderRadius:"25px",height:"83vh",overflowY:"auto"}}>
  <div  className=" " >
   
  
<div  className="ikcraft_login-input-card"style={{
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease',
   }}>
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.ID} 
          ><div
          className="drop-zone"
          onDragOver={(e) => {setHoveredDropZone(index);
            handleDragOver(e, index)
          }}
          onDrop={(e) => handleDrop(e, index)}
        
          style={{
            height: hoveredDropZone === index ?'60px':"0px",position:hoveredDropZone === index ?'relative':"",left:"10px",right:"0px",
            backgroundColor: hoveredDropZone === index ? 'rgba(149, 143, 218,0.2) ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(149, 143, 218,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"95%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"20px":"0px"
           
          }}
        ></div>
            <div
             draggable 
                    
onDragOver={(e) => { if(selectedItemIndex!==index){setHoveredDropZone(index);
    handleDragOver(e, index)}
  }}
  onDrop={(e) => {if(selectedItemIndex!==index){handleDrop(e, index);setSelectedItemIndex(null);}}}

             onDragStart={(e) =>{ handleDragStart(e, index);
              setDraggedIndex(item.ID);setSelectedItemIndex(index);
             }}
             style={{
              cursor: 'move',
             
              
            }}  className={draggedIndex == item.ID?"posFixed":"posRelative"  }
          
              onDragEnd={handleDragEnd}
            ><SectionsQuizAddMore setDeleteSectionPopUp={(id)=>{setDeleteSectionPopUp(true);setDeleteId(id)}} isLockSections={isLockSections} lockTimeSent={item.lockTime}
             changelockTime={(id,lockTime)=>updateItemlockTime(id, lockTime,item.ID)} index={index} key={item.ID} 
        
         sectionName={item.sectionName}  id={item.ID} 
           changeItemtitle={(id, sectionName)=>updateItemtitle(id, sectionName,item.ID) } onRemove={(id)=>removeItem(item.ID) } />
          </div>
          
          </div>)):'' }
  
   
    </div>   {flattenedDataLoading.length==0&&flattenedData.length==0? <div style={{fontSize:"28px",fontWeight:"bold",padding:"5px",marginTop:"45px",
                 paddingLeft:"10px",display:"flex",margin:"15px",justifyContent:"center",border:"3px solid rgba(144, 202, 249,0.41)",marginTop:"10px",background:"#ffffff",borderRadius:"15px",padding:"5px",
             display:"flex",justifyContent:"center"
            }}>
             No Section Found </div>:"" }
     { flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={index}    >
<SectionsQuizAddMoreLoading/></div>)):""}
     <div align="center">
<div align="center"  style={{width:"240px",
     }}> 
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="coloredTextV1" style={{marginTop:"15px",padding:"10px",}}>Add New Section </div>
      
      
  <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{setCreateNewSectionPopUp(true);;   }}style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",margin:"5px",marginBottom:"20px",
      background:"#958FDA"}} > <Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>
      </div>
    </div>
    </div>   <div  className=""style={{
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"50px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
         

        </div>  </div>  </div>  </div> 

  
      
                                    
     </>)  
   }
   export default SectionsQuiz;